import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB567i4bjSZCtI1u1P096NXWbLtgnAtT78",
  authDomain: "lodies-app.firebaseapp.com",
  databaseURL: "https://lodies-app.firebaseio.com",
  projectId: "lodies-app",
  storageBucket: "lodies-app.appspot.com",
  messagingSenderId: "655914477709",
  appId: "1:655914477709:web:7d8caa29916fd1c2991ac4",
  measurementId: "G-9Z2HGWG058",
};

firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
const auth = firebase.auth();
const Auth = firebase.auth;
const storage = firebase.storage();
const STATE_CHANGED = firebase.storage.TaskEvent.STATE_CHANGED;

export { firestore, auth, storage, STATE_CHANGED, Auth };
